module.exports = __webpack_public_path__ + "img/详细解决方案_04.730e1105.svg";